import './Checkbox.scss';

interface Props {
  checked: boolean;
  onChange: (label: string) => void;
  label: string;
}

export default function Checkbox({
  checked,
  onChange,
  label,
}: Props) {
  return (
    <div className='Checkbox'>
      <input
        className='Input form-check-input cursor_pointer'
        type='checkbox'
        checked={checked}
        onChange={() => onChange(label)}
      />
      <div className='Label'>
        {label}
      </div>
    </div>
  );
}
